<template>
  <div>
    <div class="row">
      <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-8" v-if="$mq !== 'xs' && $mq !== 'sm'">
        <subscribe
          :title="mainMenu.title"
          :menuId="displayMenuId"
          :bought="isLoading ? true : checkSubscribeIsBought"
          @prevSubscribe="setPrevSubscribe()"
          @nextSubscribe="setNextSubscribe()"
          :isLoading="isLoading"
          single
        />
      </div>
      <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-8 p-0" v-else>
        <subscribe
          :title="mainMenu.title"
          :menuId="displayMenuId"
          :bought="isLoading ? true : checkSubscribeIsBought"
          :isLoading="isLoading"
          single
          @show-more="showRecipePopup"
        />
        <recipe-popup
          v-if="activeRecipePopup === displayMenuId"
          :title="mainMenu.title"
          :menuId="displayMenuId"
          :bought="checkSubscribeIsBought"
          single
          @get-back="backToMenu"
        />
      </div>
      <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-4">
        <div class="k-family k-card h-100">
          <div class="k-family-header">
            <div class="k-family__title">Семья</div>
            <div
              class="k-family__add-icon cursor-pointer"
              @click="$router.push({ name: 'UserSubscribes' })"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.6448 6.60794L13.8095 6.15659C13.6992 5.80869 13.5573 5.47131 13.3861 5.14859C13.6616 4.68991 14.2407 3.7245 14.2407 3.7245C14.3515 3.54003 14.3222 3.30381 14.1702 3.15184L12.8445 1.82616C12.6926 1.67372 12.4568 1.64444 12.2719 1.75566L10.8455 2.61031C10.5246 2.44047 10.189 2.29994 9.84344 2.19053L9.39209 0.35525C9.33988 0.1465 9.15266 0 8.9375 0H7.0625C6.84734 0 6.65966 0.1465 6.60794 0.355219C6.60794 0.355219 6.29528 1.63616 6.15703 2.19006C5.78853 2.30678 5.43241 2.45831 5.09319 2.64325L3.61416 1.75566C3.42922 1.64578 3.19394 1.67419 3.0415 1.82616L1.71581 3.15184C1.56384 3.30381 1.53453 3.54003 1.64531 3.7245L2.55994 5.25206C2.41253 5.54275 2.28894 5.84531 2.19053 6.15522L0.35525 6.60794C0.1465 6.66012 0 6.84734 0 7.0625V8.9375C0 9.15266 0.1465 9.34034 0.355219 9.39206L2.19097 9.84341C2.30222 10.1963 2.44684 10.5392 2.62219 10.8683L1.80372 12.2325C1.69294 12.4169 1.72225 12.6532 1.87422 12.8051L3.19991 14.1308C3.35144 14.2823 3.58763 14.3112 3.77256 14.2013C3.77256 14.2013 4.69038 13.6511 5.13991 13.3819C5.46537 13.5554 5.80594 13.6987 6.15706 13.8099L6.60797 15.6447C6.65966 15.8535 6.84734 16 7.0625 16H8.9375C9.15266 16 9.33987 15.8535 9.39206 15.6448L9.84297 13.8099C10.2042 13.6955 10.552 13.5476 10.883 13.3682C11.3449 13.6451 12.2718 14.2013 12.2718 14.2013C12.4563 14.3116 12.6925 14.2832 12.8445 14.1308L14.1702 12.8051C14.3222 12.6532 14.3515 12.4169 14.2407 12.2325L13.3979 10.8285C13.5641 10.5131 13.7019 10.1831 13.8095 9.84341L15.6447 9.39206C15.8535 9.33987 16 9.15266 16 8.9375V7.0625C16 6.84734 15.8535 6.66012 15.6448 6.60794ZM8 11.2812C6.19091 11.2812 4.71875 9.80909 4.71875 8C4.71875 6.19091 6.19091 4.71875 8 4.71875C9.80909 4.71875 11.2812 6.19091 11.2812 8C11.2812 9.80909 9.80909 11.2812 8 11.2812Z"
                  fill="#646465"
                />
              </svg>
            </div>
          </div>
          <div class="k-family__members" v-if="isBoughtedAndFamily">
            <perfect-scrollbar>
              <div class="k-family__member" v-for="member in getUserFamilySubscribe" :key="member.id">
                <img
                  v-if="member.avatar_url"
                  class="k-family__member-avatar"
                  :src="member.avatar_url"
                  alt="avatar"
                />
                <div
                  v-else
                  class="k-family__member-avatar k-family__member-no-avatar"
                >{{ member.name[0] }}</div>
                <div class="k-family__member-name">{{ member.name }}</div>
                <div class="k-family__badges">
                  <div class="k-article__badges">
                    <span class="k-badge badge k-badge-green-light" v-show="checkUserMealType(member, 'breakfast')">Завтрак</span>
                    <span class="k-badge badge k-badge-orange-light" v-show="checkUserMealType(member, 'lunch')">Обед</span>
                    <span class="k-badge badge k-badge-green-light" v-show="checkUserMealType(member, 'brunch')">Перекус</span>
                    <span class="k-badge badge k-badge-red-light" v-show="checkUserMealType(member, 'dinner')">Ужин</span>
                  </div>
                </div>
              </div>
            </perfect-scrollbar>
          </div>
          <div v-else class="k-subscribes__no-buy-family-wrapper">
            <p
              class="k-subscribes__no-buy-family-title"
            >Здесь будут отображаться все члены семьи, которые питаются по этому меню</p>
          </div>
          <!--/ .k-family-members -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="k-card-wrapper col-12">
        <div class="k-card k-menu">
          <div class="k-menu__header">
            <filter-row
              ref="filter"
              @init="filterInit"
              @timeType="type => currentTimeType = type"
              @dishType="type => currentDishType = type"
              @day="date => currentDateDay = date"
              @week="date => currentDateWeek = date"
              :regular="mainMenu"
            />
          </div>

          <div v-if="menuError" role="alert" class="recovery-notice">
            {{ menuError }}
            <button type="button" @click="retryMenu">Повторить загрузку</button>
          </div>
          <k-spinner v-else-if="isLoading" class="mx-auto" />
          <div v-else-if="isNextWeekNotAvaiable || isPrevWeekNotAvaiable">
            <div class="soon-wrapper">Меню за выбранный период недоступно. Выберите текущую неделю.</div>
          </div>
          <div v-else-if="!hasScheduledMeals" class="soon-wrapper" role="status">
            <p>{{ currentTimeType === 'day' ? 'Меню на выбранный день пока не опубликовано.' : 'Меню на выбранную неделю пока не опубликовано.' }}</p>
          </div>
          <div v-else>
            <div style="text-align: center;">
              <BaseInput
                  v-model="searchRecipe"
                  title="Название рецепта"
                  placeholder="Поиск рецептов по названию"
                  class="search-input"
                  clearable
              />
            </div>
            <div class="k-menu__body" v-if="currentTimeType === 'week'">
              <div class="k-menu__daily" v-for="(day, index) in getFilteredWeekMeals" :key="index">
                <div class="k-menu__daily-title">
                  {{ dateFormat(day.date, 'dddd') }}
                  <div class="k-menu__daily-subtitle">{{ dateFormat(day.date, 'dd mmmm') }}</div>
                </div>
                <div class="k-menu__dishes-wrapper">
                  <div>
                    <div
                      v-for="(meals, mealsIndex) in getGroupedDayMeals(getActualMeals(day.meals))"
                      :key="mealsIndex"
                    >
                      <div class="k-menu__daily-title k-menu__daily-title--low mb-1" v-if="currentDishType === 'all'">{{ getMealType(meals[0].meal_type) }}</div>
                      <div class="d-flex flex-wrap">
                        <div
                          class="k-menu__dish-card mb-2"
                          v-for="(meal, mealIndex) in meals"
                          :key="mealIndex"
                          role="button"
                          tabindex="0"
                          :aria-label="recipeActionLabel(meal)"
                          @click="openRecipe(meal)"
                          @keydown.enter.prevent="openRecipe(meal)"
                          @keydown.space.prevent="openRecipe(meal)"
                        >
                          <div
                            :class="{'k-menu__dish': true, disabled: !checkSubscribeIsBought || !isCurrentBoughtedSubscribeMealTypes(meal.meal_type)}"

                          >
                            <div class="k-menu__dish-photo col-4">
                              <img class="k-menu__dish-img" :src="meal.recipe.cover_url" />
                            </div>
                            <div class="k-menu__dish-body w-100">
                              <!-- <div class="k-menu__dish-title">{{ getMealType(meal.meal_type) }}</div> -->
                              <div class="k-menu__dish-description d-flex justify-content-between">
                                <span class="d-flex flex-column">
                                  <span class="k-menu__warning-text" v-if="meal.recipe.preparing_desc">
                                    <svg class="mr-1" width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8.86037 6.23744C8.85784 6.23261 8.8552 6.22787 8.85243 6.22318L5.50428 0.578479C5.04727 -0.193571 3.95166 -0.192081 3.49587 0.578479L0.147729 6.22318C0.144951 6.22785 0.142314 6.23261 0.139783 6.23742C-0.277645 7.03679 0.29027 8 1.17521 8H7.82495C8.71192 8 9.27681 7.03496 8.86037 6.23744ZM7.82495 7.40072H1.17521C0.734487 7.40072 0.452287 6.92385 0.65412 6.52597L3.99789 0.888686C4.22635 0.502427 4.77426 0.503199 5.00227 0.888686C5.00232 0.888793 5.00239 0.888883 5.00246 0.889009L8.34603 6.52599C8.54801 6.92413 8.26542 7.40072 7.82495 7.40072Z" fill="#D51E3A"/>
                                      <path d="M4.50029 2.01074C4.33827 2.01074 4.20691 2.14489 4.20691 2.31039V5.3068C4.20691 5.47229 4.33825 5.60645 4.50029 5.60645C4.66231 5.60645 4.79367 5.47229 4.79367 5.3068V2.31039C4.79367 2.14491 4.66231 2.01074 4.50029 2.01074Z" fill="#D51E3A"/>
                                      <path d="M4.50029 6.20508C4.33843 6.20508 4.20691 6.33968 4.20691 6.50473C4.20691 6.66978 4.33841 6.80438 4.50029 6.80438C4.66215 6.80438 4.79367 6.66978 4.79367 6.50473C4.79367 6.33968 4.66215 6.20508 4.50029 6.20508Z" fill="#D51E3A"/>
                                    </svg>
                                    Требуется подготовка
                                  </span>
                                  {{ meal.recipe.title }}
                                </span>
                                <svg class="k-menu__lock ml-2" v-if="!checkSubscribeIsBought || !isCurrentBoughtedSubscribeMealTypes(meal.meal_type)" width="17" height="24" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.1312 9.49941V5.80519C14.1312 2.63873 11.5812 0 8.4999 0C5.41865 0 2.86865 2.63873 2.86865 5.80519V9.49941H5.7374V5.80519C5.63115 4.22196 6.90615 2.84982 8.4999 2.84982C10.0937 2.84982 11.3687 4.11641 11.3687 5.80519V9.49941H14.1312Z" fill="#C1C1C1"/>
                                  <path d="M0 13.0883V20.3711C0 21.9544 1.275 23.221 2.86875 23.221H14.2375C15.8312 23.221 17.1063 21.9544 17.1063 20.2656V12.9827C17.1063 11.3995 15.8312 10.0273 14.2375 10.0273H2.86875C1.275 10.1329 0 11.505 0 13.0883ZM8.5 14.4604C9.24375 14.4604 9.88125 15.0937 9.88125 15.9381C9.88125 16.4658 9.5625 16.888 9.1375 17.2047V19.6323C9.1375 20.0545 8.81875 20.3711 8.39375 20.3711C7.96875 20.3711 7.65 20.0545 7.65 19.6323V17.2047C7.225 16.9936 6.90625 16.4658 6.90625 15.9381C7.11875 15.1992 7.75625 14.4604 8.5 14.4604Z" fill="#C1C1C1"/>
                                </svg>

                              </div>
                              <div class="k-menu__dish-calories align-items-center justify-content-between w-100">
                                <div v-if="meal.recipe.info" class="d-flex align-items-center">
                                  <div class="badge k-badge k-badge-orange-light">
                                    Ккал
                                    {{ meal.recipe.info.calories }}
                                  </div>
                                  <div class="badge k-badge-multi">
                                    <div class="k-badge-red-light">Б {{ Math.round(meal.recipe.info.proteinsWeight * 100 / meal.recipe.mass_change) }}</div>
                                    <div class="k-badge-orange-light">Ж {{ Math.round(meal.recipe.info.fatsWeight * 100 / meal.recipe.mass_change) }}</div>
                                    <div
                                      class="k-badge-green-light"
                                    >У {{ Math.round(meal.recipe.info.carbohydratesWeight * 100 / meal.recipe.mass_change) }}</div>
                                  </div>
                                </div>
                                <svg
                                  v-if="checkSubscribeIsBought && isCurrentBoughtedSubscribeMealTypes(meal.meal_type)"
                                  @click.stop="setWillNotCook(meal)"
                                  width="22"
                                  height="22"
                                  viewBox="0 0 22 22"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.8125 19.5625C4.8125 20.6996 5.73787 21.625 6.875 21.625C8.01213 21.625 8.9375 20.6996 8.9375 19.5625C8.9375 18.4254 8.01213 17.5 6.875 17.5C5.73787 17.5 4.8125 18.4254 4.8125 19.5625ZM7.5625 19.5625C7.5625 19.9413 7.25381 20.25 6.875 20.25C6.49619 20.25 6.1875 19.9413 6.1875 19.5625C6.1875 19.1837 6.49619 18.875 6.875 18.875C7.25381 18.875 7.5625 19.1837 7.5625 19.5625Z"
                                    :fill="getFillColorByMeal(meal)"
                                  />
                                  <path
                                    d="M17.1875 19.5625C17.1875 18.4254 16.2621 17.5 15.125 17.5C13.9879 17.5 13.0625 18.4254 13.0625 19.5625C13.0625 20.6996 13.9879 21.625 15.125 21.625C16.2621 21.625 17.1875 20.6996 17.1875 19.5625ZM14.4375 19.5625C14.4375 19.1837 14.7462 18.875 15.125 18.875C15.5038 18.875 15.8125 19.1837 15.8125 19.5625C15.8125 19.9413 15.5038 20.25 15.125 20.25C14.7462 20.25 14.4375 19.9413 14.4375 19.5625Z"
                                    :fill="getFillColorByMeal(meal)"
                                  />
                                  <path
                                    d="M2.81875 3.0625C2.904 3.87444 3.85275 12.8862 3.99919 14.2784C4.10987 15.3309 4.99194 16.125 6.05069 16.125H16.764C17.7299 16.125 18.5783 15.4389 18.7811 14.4943L20.4325 6.78806C20.5198 6.37969 20.4194 5.95963 20.1568 5.63581C19.8942 5.31131 19.5044 5.125 19.0871 5.125H4.41856L4.12156 2.3035C4.08444 1.95288 3.7895 1.6875 3.4375 1.6875H1.375C0.9955 1.6875 0.6875 1.9955 0.6875 2.375C0.6875 2.7545 0.9955 3.0625 1.375 3.0625H2.81875ZM19.0871 6.5L17.4364 14.2062C17.3683 14.5211 17.0857 14.75 16.7633 14.75H6.05069C5.69731 14.75 5.40375 14.4853 5.36663 14.1347L4.56294 6.5H19.0871Z"
                                    :fill="getFillColorByMeal(meal)"
                                  />
                                  <!-- <rect
                                    x="20.7988"
                                    width="1.5"
                                    height="28"
                                    rx="0.75"
                                    transform="rotate(45 20.7988 0)"
                                    fill="#A3A3A3"
                                    v-if="meal.recipe.will_not_cook === 't'"
                                  /> -->
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="isNoRecipes(day.meals)" class="soon-wrapper">
                      <p>Нет доступных блюд</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="k-menu__body" v-else-if="currentTimeType === 'day'">
              <div v-for="(day, index) in dayMenu" :key="index">
                <div v-if="getGroupedDayMeals(day.meals).length > 0">
                  <div
                    class="k-menu__daily"
                    v-for="(meals, mealsIndex) in getGroupedDayMeals(day.meals)"
                    :key="mealsIndex"
                  >
                    <div class="k-menu__daily-title">{{ getMealType(meals[0].meal_type) }}</div>
                    <div class="k-menu__dishes-wrapper">
                      <div class="row" style="justify-content: center;">
                        <div
                          class="k-menu__dish-card mb-2"
                          v-for="(meal, mealIndex) in getActualMeals(meals)"
                          :key="mealIndex"
                          role="button"
                          tabindex="0"
                          :aria-label="recipeActionLabel(meal)"
                          @click="openRecipe(meal)"
                          @keydown.enter.prevent="openRecipe(meal)"
                          @keydown.space.prevent="openRecipe(meal)"
                        >
                          <div
                            :class="{'k-menu__dish': true, disabled: !canOpenRecipe(meal)}"
                          >
                            <div class="k-menu__dish-photo col-4">
                              <img
                                class="k-menu__dish-img"
                                :src="meal.recipe.cover_url"
                              />
                            </div>
                            <div class="k-menu__dish-body w-100">
                              <!-- <div class="k-menu__dish-title">{{ getMealType(meal.meal_type) }}</div> -->
                              <div class="k-menu__dish-description d-flex justify-content-between">
                                <span class="d-flex flex-column">
                                  <span class="k-menu__warning-text" v-if="meal.recipe.preparing_desc">
                                    <svg class="mr-1" width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8.86037 6.23744C8.85784 6.23261 8.8552 6.22787 8.85243 6.22318L5.50428 0.578479C5.04727 -0.193571 3.95166 -0.192081 3.49587 0.578479L0.147729 6.22318C0.144951 6.22785 0.142314 6.23261 0.139783 6.23742C-0.277645 7.03679 0.29027 8 1.17521 8H7.82495C8.71192 8 9.27681 7.03496 8.86037 6.23744ZM7.82495 7.40072H1.17521C0.734487 7.40072 0.452287 6.92385 0.65412 6.52597L3.99789 0.888686C4.22635 0.502427 4.77426 0.503199 5.00227 0.888686C5.00232 0.888793 5.00239 0.888883 5.00246 0.889009L8.34603 6.52599C8.54801 6.92413 8.26542 7.40072 7.82495 7.40072Z" fill="#D51E3A"/>
                                      <path d="M4.50029 2.01074C4.33827 2.01074 4.20691 2.14489 4.20691 2.31039V5.3068C4.20691 5.47229 4.33825 5.60645 4.50029 5.60645C4.66231 5.60645 4.79367 5.47229 4.79367 5.3068V2.31039C4.79367 2.14491 4.66231 2.01074 4.50029 2.01074Z" fill="#D51E3A"/>
                                      <path d="M4.50029 6.20508C4.33843 6.20508 4.20691 6.33968 4.20691 6.50473C4.20691 6.66978 4.33841 6.80438 4.50029 6.80438C4.66215 6.80438 4.79367 6.66978 4.79367 6.50473C4.79367 6.33968 4.66215 6.20508 4.50029 6.20508Z" fill="#D51E3A"/>
                                    </svg>
                                    Требуется подготовка
                                  </span>
                                  {{ meal.recipe.title }}
                                </span>
                                <svg class="k-menu__lock ml-2" v-if="!checkSubscribeIsBought || !isCurrentBoughtedSubscribeMealTypes(meal.meal_type)" width="17" height="24" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.1312 9.49941V5.80519C14.1312 2.63873 11.5812 0 8.4999 0C5.41865 0 2.86865 2.63873 2.86865 5.80519V9.49941H5.7374V5.80519C5.63115 4.22196 6.90615 2.84982 8.4999 2.84982C10.0937 2.84982 11.3687 4.11641 11.3687 5.80519V9.49941H14.1312Z" fill="#C1C1C1"/>
                                  <path d="M0 13.0883V20.3711C0 21.9544 1.275 23.221 2.86875 23.221H14.2375C15.8312 23.221 17.1063 21.9544 17.1063 20.2656V12.9827C17.1063 11.3995 15.8312 10.0273 14.2375 10.0273H2.86875C1.275 10.1329 0 11.505 0 13.0883ZM8.5 14.4604C9.24375 14.4604 9.88125 15.0937 9.88125 15.9381C9.88125 16.4658 9.5625 16.888 9.1375 17.2047V19.6323C9.1375 20.0545 8.81875 20.3711 8.39375 20.3711C7.96875 20.3711 7.65 20.0545 7.65 19.6323V17.2047C7.225 16.9936 6.90625 16.4658 6.90625 15.9381C7.11875 15.1992 7.75625 14.4604 8.5 14.4604Z" fill="#C1C1C1"/>
                                </svg>
                              </div>
                              <div class="k-menu__dish-calories align-items-center justify-content-between w-100">
                                <div v-if="meal.recipe.info" class="d-flex align-items-center">
                                  <div class="badge k-badge k-badge-orange-light">
                                    Ккал
                                    {{ meal.recipe.info.calories }}
                                  </div>
                                  <div class="badge k-badge-multi">
                                    <div class="k-badge-red-light">Б {{ Math.round(meal.recipe.info.proteinsWeight * 100 / meal.recipe.mass_change) }}</div>
                                    <div class="k-badge-orange-light">Ж {{ Math.round(meal.recipe.info.fatsWeight * 100 / meal.recipe.mass_change) }}</div>
                                    <div
                                      class="k-badge-green-light"
                                    >У {{ Math.round(meal.recipe.info.carbohydratesWeight * 100 / meal.recipe.mass_change) }}</div>
                                  </div>
                                </div>
                                <svg
                                  v-if="checkSubscribeIsBought && isCurrentBoughtedSubscribeMealTypes(meal.meal_type)"
                                  @click.stop="setWillNotCook(meal)"
                                  width="22"
                                  height="22"
                                  viewBox="0 0 22 22"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.8125 19.5625C4.8125 20.6996 5.73787 21.625 6.875 21.625C8.01213 21.625 8.9375 20.6996 8.9375 19.5625C8.9375 18.4254 8.01213 17.5 6.875 17.5C5.73787 17.5 4.8125 18.4254 4.8125 19.5625ZM7.5625 19.5625C7.5625 19.9413 7.25381 20.25 6.875 20.25C6.49619 20.25 6.1875 19.9413 6.1875 19.5625C6.1875 19.1837 6.49619 18.875 6.875 18.875C7.25381 18.875 7.5625 19.1837 7.5625 19.5625Z"
                                    :fill="getFillColorByMeal(meal)"
                                  />
                                  <path
                                    d="M17.1875 19.5625C17.1875 18.4254 16.2621 17.5 15.125 17.5C13.9879 17.5 13.0625 18.4254 13.0625 19.5625C13.0625 20.6996 13.9879 21.625 15.125 21.625C16.2621 21.625 17.1875 20.6996 17.1875 19.5625ZM14.4375 19.5625C14.4375 19.1837 14.7462 18.875 15.125 18.875C15.5038 18.875 15.8125 19.1837 15.8125 19.5625C15.8125 19.9413 15.5038 20.25 15.125 20.25C14.7462 20.25 14.4375 19.9413 14.4375 19.5625Z"
                                    :fill="getFillColorByMeal(meal)"
                                  />
                                  <path
                                    d="M2.81875 3.0625C2.904 3.87444 3.85275 12.8862 3.99919 14.2784C4.10987 15.3309 4.99194 16.125 6.05069 16.125H16.764C17.7299 16.125 18.5783 15.4389 18.7811 14.4943L20.4325 6.78806C20.5198 6.37969 20.4194 5.95963 20.1568 5.63581C19.8942 5.31131 19.5044 5.125 19.0871 5.125H4.41856L4.12156 2.3035C4.08444 1.95288 3.7895 1.6875 3.4375 1.6875H1.375C0.9955 1.6875 0.6875 1.9955 0.6875 2.375C0.6875 2.7545 0.9955 3.0625 1.375 3.0625H2.81875ZM19.0871 6.5L17.4364 14.2062C17.3683 14.5211 17.0857 14.75 16.7633 14.75H6.05069C5.69731 14.75 5.40375 14.4853 5.36663 14.1347L4.56294 6.5H19.0871Z"
                                    :fill="getFillColorByMeal(meal)"
                                  />
                                  <!--<rect
                                    x="20.7988"
                                    width="1.5"
                                    height="28"
                                    rx="0.75"
                                    transform="rotate(45 20.7988 0)"
                                    fill="#A3A3A3"
                                    v-if="meal.recipe.will_not_cook === 't'"
                                  />-->
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="isNoRecipes(meals)" class="soon-wrapper">
                          <p>Нет доступных блюд</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="soon-wrapper">
                  <p>Нет доступных блюд</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{'buy-status': true, 'green': status == 'f', 'red': status == 't'}">
      <p v-if="status == 'f'">Добавлено в список покупок</p>
      <p v-if="status == 't'">Удалено из списка покупок</p>
      <img
        src="../assets/Group302.svg"
        alt="avatar"
        @click="status = undefined"
        v-if="status"
      />
    </div>
    <div :class="{'buy-status': true, 'red': notification}">
      <p>Купите меню, чтобы посмотреть рецепт</p>
      <!-- Для доступа необходимо приобрести -->
      <img
        src="../assets/Group302.svg"
        alt="avatar"
        @click="notification = undefined"
      />
    </div>
  </div>
</template>

<script>
import { readFailure } from "../utils/legacy-safety";
import { replaceIfChanged } from "../utils/readNavigation";
import Subscribe from "../components/TheSubscribe";
import FilterRow from "../components/TheFilterRow.vue";
import KSpinner from "../components/TheSpinner.vue";
import { getRegularMenuWeek, getRegularMenuDay } from "../api/RegularApi";
import { setMealData } from "../api/PurchasesApi";
import dateFormat from "../utils/dateformat";
import { mapGetters } from "vuex";
import { groupBy } from "../utils/helper";
import AdaptivePropper from "../components/TheAdaptivePropper.vue";
import RecipePopup from '../components/TheRecipePopup.vue';

import { getMonday } from '../utils/helper';
import BaseInput from "@/components/elements/BaseInput";

export default {
  name: 'ReceipesRegular',
  // eslint-disable-next-line vue/no-unused-components
  components: {BaseInput, FilterRow, KSpinner, Subscribe, AdaptivePropper, RecipePopup },
  data: () => ({
    weekMenu: [],
    dayMenu: [],
    mainMenu: {},
    dateFormat,
    currentRegularId: null,
    currentDishType: "all",
    currentTimeType: "week",
    currentDateDay: new Date(),
    currentDateWeek: {
      from: getMonday(new Date()),
      to: getMonday(new Date()).setDate(getMonday(new Date()).getDate() + 6)
    },

    isLoading: false,
    menuError: false,
    filterInited: false,
    slickOptions: {
      slidesToShow: 1,
      arrows : false,
      dots: true,
    },
    activeRecipePopup: undefined,
    status: undefined,
    notification: undefined,

    searchRecipe: '',
  }),
  created() {
    if (this.$route.query.search) {
      this.searchRecipe = this.$route.query.search;
    }
    if (this.$route.params.id) {
      this.currentRegularId = this.$route.params.id;
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getMealReferences",
      "getUserFamily",
      "getUserSubscribes",
      "getUserSets",
      "getAvaiableUserSubscribes",
    ]),

    displayMenuId() {
      return this.currentRegularId || this.mainMenu.id || '21ffc672-02ca-411b-b210-97351f996512';
    },
    accessSignature() { return JSON.stringify([this.getUser && this.getUser.id, this.getUserSubscribes.map(s => [s.menu_id, s.is_paid, s.started_at, s.finished_at, s.meal_types])]); },
    isPreview() { return this.mainMenu.access === 'preview'; },
    hasScheduledMeals() {
      const days = this.currentTimeType === 'day' ? this.dayMenu : this.weekMenu;
      return days.some(day => day.meals.some(meal => meal.recipe));
    },
    isSomebodyInMenu() {
      return this.getUserSubscribes.find(el => el.menu_id === this.mainMenu.id)?.profile_subscription_meals?.length > 0;
    },

    isNextWeekNotAvaiable() {
      if (!this.mainMenu.id) return false;

      const notAvailMonday = (getMonday(new Date())).setDate((getMonday(new Date())).getDate() + 21)
      const notAvailMondayZeroTime = new Date(new Date(notAvailMonday).setHours(0,0,0,0));

      const nextMonday = (getMonday(new Date(this.currentDateWeek.to))).setDate((getMonday(new Date(this.currentDateWeek.to))).getDate() + 7)
      const nextMondayZeroTime = new Date(new Date(nextMonday).setHours(0,0,0,0));

      return new Date(nextMondayZeroTime).getTime() >= new Date(notAvailMondayZeroTime).getTime()
    },
    isPrevWeekNotAvaiable() {
      if (!this.mainMenu.id) return false;

      const notAvailMonday = (getMonday(new Date())).setDate((getMonday(new Date())).getDate() - 7)
      const notAvailMondayZeroTime = new Date(new Date(notAvailMonday).setHours(0,0,0,0));

      const prevMonday = (getMonday(new Date(this.currentDateWeek.to))).setDate((getMonday(new Date(this.currentDateWeek.to))).getDate())
      const prevMondayZeroTime = new Date(new Date(prevMonday).setHours(0,0,0,0));

      return new Date(prevMondayZeroTime).getTime() <= new Date(notAvailMondayZeroTime).getTime()
    },

    getAvaiableUserSubscribesPaids() {
      return this.getAvaiableUserSubscribes
        .filter(el => el.id === '21ffc672-02ca-411b-b210-97351f996512')

    },
    getFilteredWeekMeals() {
      return this.weekMenu.map(day => ({
        date: day.date,
        meals: day.meals.filter(meal =>
          (this.currentDishType === 'all' || meal.meal_type === this.currentDishType) &&
          meal.recipe && meal.recipe.title.toLowerCase().includes(this.searchRecipe.toLowerCase())
        )
      }));
    },
    checkSubscribeIsBought() {
      if (this.isPreview) return false;
      return (
        this.getUserSubscribes.some(el => el.menu_id === this.mainMenu.id && el.is_paid === 't' ) ||
        this.getUserSets.some(el => el.recipe_set_id === this.mainMenu.id && el.is_paid === 't')
      );
    },
    isBoughtedAndFamily() {
      return this.getUserSubscribes.find(el => el.menu_id === this.mainMenu.id)?.profile_subscription_meals?.length > 0;
    },
    getUserFamilySubscribe() {
      return this.getUserFamily.map(el => {
        const current = this.getUserSubscribes.find(el => el.menu_id === this.mainMenu.id)?.profile_subscription_meals?.find(u => {
          return u.profile_id === el.id;
        })
        return {
          ...el,
          subscribe: current,
        }
      }).filter(el => el.subscribe)
    }
  },
  beforeDestroy() { this._readSequence = (this._readSequence || 0) + 1; },
  watch: {
    accessSignature() { if (this.currentRegularId) this.retryMenu(); },
    '$route.params.id'(id) { if (id && id !== this.currentRegularId) this.currentRegularId = id; },
    getAvaiableUserSubscribesPaids() {
      if (this.getAvaiableUserSubscribesPaids.length > 0 && !this.currentRegularId) {
        this.currentRegularId = this.getAvaiableUserSubscribesPaids[0].id;
      }
    },
    currentTimeType(value) {
      if (value === "day") {
        this.loadDay(this.currentDateDay);
      } else {
        this.loadWeek(this.currentDateWeek.from);
      }
    },
    currentDateDay(value) {
      this.loadDay(value);
    },
    currentDateWeek(value) {
      this.loadWeek(value.from);
    },
    currentRegularId(value) {
       replaceIfChanged(this.$router, { name: 'ReceipesRegular', params: { id: value }, query: { ...this.$route.query }}, { background: true })

      if (this.currentTimeType === "week") {
        this.loadWeek(this.currentDateWeek.from);
      } else {
        this.loadDay(this.currentDateDay);
      }
    }
  },
  methods: {
    canOpenRecipe(meal) {
      return !this.isPreview && this.checkSubscribeIsBought && this.isCurrentBoughtedSubscribeMealTypes(meal.meal_type);
    },
    recipeActionLabel(meal) {
      return meal.recipe.title + (this.canOpenRecipe(meal) ? '. Открыть рецепт' : '. Рецепт закрыт, нужен доступ');
    },
    openRecipe(meal) {
      if (!this.canOpenRecipe(meal)) { this.notification = true; return; }
      this.$root.$emit('SHOW_RECIPE', { date: meal.date, meal_id: meal.id, menu: this.mainMenu.id, recipe_id: meal.recipe.id });
    },
    checkCurrentSubscribeIsBought(subscribe) {
      return this.getUserSubscribes.some(el => el.menu_id === subscribe.id && el.is_paid === 't' );
    },
    setPrevSubscribe() {
      if (this.getAvaiableUserSubscribesPaids.length <= 1) return;
      const currentIndex = this.getAvaiableUserSubscribesPaids.findIndex(el => el.id === this.currentRegularId);
      if (this.getAvaiableUserSubscribesPaids[currentIndex + 1]) {
        this.currentRegularId = this.getAvaiableUserSubscribesPaids[currentIndex + 1].id;
      } else {
        this.currentRegularId = this.getAvaiableUserSubscribesPaids[0].id;
      }
    },
    setNextSubscribe() {
      if (this.getAvaiableUserSubscribesPaids.length <= 1) return;
      const currentIndex = this.getAvaiableUserSubscribesPaids.findIndex(el => el.id === this.currentRegularId);
      if (this.getAvaiableUserSubscribesPaids[currentIndex - 1]) {
        this.currentRegularId = this.getAvaiableUserSubscribesPaids[currentIndex - 1].id;
      } else {
        this.currentRegularId = this.getAvaiableUserSubscribesPaids[this.getAvaiableUserSubscribesPaids.length - 1].id;
      }
    },
    isCurrentBoughtedSubscribeMealTypes(type) {
      if (this.isPreview) return false;
      const current = this.getUserSubscribes.find(el => el.menu_id === this.mainMenu.id && el.is_paid === 't' );
      if (!current) return false;

      return current.meal_types.includes(type);
    },
    checkUserMealType(member, type) {
      const subscribeUsers = this.getUserSubscribes.find(el => el.menu_id === this.mainMenu.id)?.profile_subscription_meals;
      if (!subscribeUsers) return;
      const user = subscribeUsers.find(el => el.profile_id === member.id)
      if (!user) return;
      return JSON.parse(user.meal_types).some(el => el === type);
    },
    async setWillNotCook(meal) {
      if (!this.isSomebodyInMenu) {
        this.$root.$emit('notify', {
          type: 'red',
          text: 'Чтобы управлять списком покупок, добавьте в меню хотя бы один профиль'
        })
        return;
      }
      const dates = {
        start_date:
          this.currentTimeType === "day"
            ? this.currentDateDay
            : this.currentDateWeek.from,
        end_date:
          this.currentTimeType === "day"
            ? this.currentDateDay
            : this.currentDateWeek.to || this.currentDateWeek.from
      };
      await setMealData({
        ...dates,
        meal_id: meal.id,
        recipe_id: meal.recipe.id,
        will_not_cook: meal.recipe.will_not_cook === "t" ? "f" : "t"
      });

      meal.recipe.will_not_cook = meal.recipe.will_not_cook === "t" ? "f" : "t";
      this.$forceUpdate();
      /*
      if (this.currentTimeType === 'day') {
        await this.loadDay();
      } else {
        await this.loadWeek();
      }
      */
      this.status = meal.recipe.will_not_cook;
    },
    getActualMeals(meals) {
      return meals.filter(el => el.recipe && el.recipe.title.toLowerCase().includes(this.searchRecipe.toLowerCase()));
    },
    isNoRecipes(meal) {
      return meal.every(el => !el.recipe);
    },
    getSortedMeals(source) {
      const sortingArray = Object.keys(this.getMealReferences);

      return source.slice().sort(function(a, b) {
        return (
          sortingArray.indexOf(a[0].meal_type) -
          sortingArray.indexOf(b[0].meal_type)
        );
      });
    },
    loadWeek(date) { return this.loadMenuPage('week', date); },
    loadDay(date) { return this.loadMenuPage('day', date); },
    retryMenu() {
      return this.currentTimeType === 'day' ? this.loadDay(this.currentDateDay) : this.loadWeek(this.currentDateWeek.from);
    },
    async loadMenuPage(kind, date) {
      const sequence = this._readSequence = (this._readSequence || 0) + 1;
      this.isLoading = true;
      this.menuError = false;
      try {
        const request = kind === 'week' ? getRegularMenuWeek : getRegularMenuDay;
        const { data } = (await request(date, this.currentRegularId)).data;
        const { meals, ...menu } = data.menu;
        if (sequence !== this._readSequence) return;
        if (kind === 'week') this.weekMenu = meals;
        else this.dayMenu = meals;
        this.mainMenu = menu;
      } catch (error) {
        if (sequence === this._readSequence) this.menuError = readFailure(error, 'Не удалось загрузить меню. Повторите запрос.');
      } finally {
        if (sequence === this._readSequence) this.isLoading = false;
      }
    },
    async filterInit(payload) {
      const { currentDishType, currentTimeType } = payload;

      this.currentDishType = currentDishType;
      this.currentTimeType = currentTimeType;

      if (this.getAvaiableUserSubscribesPaids.length > 0 && !this.currentRegularId) {
        this.currentRegularId = this.getAvaiableUserSubscribesPaids[0].id;
      } else {
        if (currentTimeType === "week") {
          this.loadWeek(this.currentDateWeek.from);
        } else {
          this.loadDay(this.currentDateDay);
        }
      }
    },
    getMealType(meal_type) {
      return this.getMealReferences[meal_type];
    },
    getGroupedDayMeals(meals) {
      return this.getSortedMeals(groupBy(meals, "meal_type"));
    },
    showRecipePopup(id) {
      console.log(id)
      this.activeRecipePopup = id;
    },
    backToMenu() {
      this.activeRecipePopup = undefined;
    },
    showNotify(condition) {
      console.log('cond', condition)
      if (condition) return;
      this.notification = true;
    },
    getFillColorByMeal(meal) {
      if (!this.isSomebodyInMenu) {
        return  '#A3A3A3';
      }
      if (meal.recipe.will_not_cook === 'f') {
        return '#D51E3A';
      }
      if (meal.recipe.will_not_cook === 't') {
        return '#9DC43B';
      }
      return  '#A3A3A3';
    }
  }
};
</script>

<style lang="scss" scoped>
.k-menu__dish-card[role="button"]:focus-visible { outline: 2px solid #f68c1e; outline-offset: 3px; }
.k-ingredient-card__action-icon {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.active {
    background: #f68c1e;
    border-radius: 50%;

    path,
    circle {
      fill: #fff !important;
    }
  }
}

.k-subscribes__no-buy-family-title {
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  letter-spacing: -0.41px;
  color: #77767e;
  opacity: 0.6;
  text-align: center;
  margin: 0;

  &--bold {
    font-weight: bold;
    font-size: 22px;
  }
}
.k-subscribes__buy-empty-family-wrapper,
.k-subscribes__no-buy-family-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0 40px;
}

.k-subscribes__buy-empty-family-wrapper {
  flex-direction: column;
}
.k-menu__lock {
  min-width: 17px;
}
.k-menu__warning-text {
  display: flex;
  font-size: 10px;
  color: #D51E3A;
  align-items: center;
}
.buy-status {
  position: fixed;
  bottom: -80px;
  right: 20px;
  border-radius: 4px;
  transition: 0.2s linear;
  padding: 16px;
  width: auto;
  min-height: 80px;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  justify-content: space-between;
  // background: #F9FAFB;
  &.green { background: #9DC43B; bottom: 20px; z-index: 1; }
  &.red { background: #C23440; bottom: 20px; z-index: 1; }
  // &.buy-notification {
  //   background-color: black;
  //   // background: #F9FAFB;
  //   // border: 1px solid #666666;
  //   bottom: 20px;
  //   z-index: 1;
  // }
  p {
    align-self: center;
    color: white;
    margin: 0 10px;
  }
  img {
    align-self: flex-start;
    margin-left: 10px;
  }
}
.disabled {
  pointer-events: none;
}

.search-input {
  margin-top: 0;
}

@media (max-width: 767.98px) {
  .search-input {
    width: 100%;
  }
}

.k-menu__daily {
  width: 420px;
  max-width: 420px;
  margin: 0 auto;
}

@media (max-width: 767.98px) {
  .k-menu__daily {
    width: 100%;
    max-width: 100%;
  }
}

@media (min-width: 1124px) {
  .k-menu__daily {
    width: 840px;
    max-width: 840px;
  }
}

@media (min-width: 1544px) {
  .k-menu__daily {
    width: 1260px;
    max-width: 1260px;
  }
}
@media (max-width: 375px) {
  .k-menu__dish-card, .k-menu__dish-body { min-width: 0; max-width: 100%; }
  .k-menu__dish-calories { flex-wrap: wrap; gap: 3px; overflow-wrap: anywhere; }
  .k-menu__dish-calories > .d-flex { flex-wrap: wrap; min-width: 0; max-width: 100%; }
  .k-menu__dish-description { min-width: 0; overflow-wrap: anywhere; }
}
</style>
